import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import PhotoCamera from '@material-ui/icons/PhotoCamera';

import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'axios';
import RefreshToken from '../../../partials/RefreshToken';
import { AuthContext } from '../../../../@jumbo/components/context/AuthContext';
import { useSnackbar } from 'notistack';
import Loding from 'routes/partials/Loding';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  imgStyle: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: '100%',
    maxWidth: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  selectStyle: {
    [`& fieldset`]: {
      borderRadius: 25,
    },
    [`& .MuiSelect-outlined`]: {
      borderRadius: 25,
    },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const TierAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const NoImage = '/images/icons/system.png';
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const [id, setId] = useState('');

  const [recurrence, setRecurrence] = useState('');
  const [maxNumberOfTransaction, setMaxNumberOfTransaction] = useState('');
  const [maxTotalAmountOfTransaction, setMaxTotalAmountOfTransaction] = useState('');

  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  console.log('editForm', editForm);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const clearStates = () => {
    setId('');
    setRecurrence('');
    setMaxNumberOfTransaction('');
    setMaxTotalAmountOfTransaction('');

    setEditObj({});
  };

  const onSubmit = async e => {
    // return console.log('image file', imageFile)
    // return console.log('ddddd', imageFile);
    e.preventDefault();

    console.log('onSubmit');
    console.log('editIndexNo', editIndexNo);
    e.preventDefault();
    setLoading(true);
    let response;
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    let data = {
      recurrence,
      maxNumberOfTransaction,
      maxTotalAmountOfTransaction,
    };

    try {
      if (addForm) {
        response = await axios({
          url: `/api/v1/private/limit-restriction`,
          method: 'post',
          data: data,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setList([...list, response.data.data]);

        console.log('addForm response', response);
      } else if (editForm) {
        response = await axios({
          url: `/api/v1/private/limit-restriction/${id}`,
          method: 'put',
          data: data,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log('editForm response', response);

        list[editIndexNo] = response.data.data;
        setRefresh(!refresh);
      }

      closeAddDialog();
      activeAddForm();
      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      console.log('error', error);
      console.log('errorresponse', error.response);

      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);

    // handleSnakbarOpen()
  };

  useEffect(() => {
    console.log('loading edit data', editObj);

    if (editObj.id) {
      console.log('loading edit data 2');

      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setRecurrence(editObj.recurrence);
      setMaxNumberOfTransaction(editObj.maxNumberOfTransaction);
      setMaxTotalAmountOfTransaction(editObj.maxTotalAmountOfTransaction);
    }
  }, [editObj]);

  const activeAddForm = () => {
    clearStates();
  };

  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);

  return (
    <React.Fragment>
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Limit' : 'Add Limit'}
        </Typography>
      </div>

      <form onSubmit={onSubmit}>
        <TextField
          variant="outlined"
          select
          label="Recurrence"
          size="small"
          fullWidth
          required
          value={recurrence}
          onChange={e => setRecurrence(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value="Yearly">Yearly</MenuItem>
          <MenuItem value="Monthly">Monthly</MenuItem>
          <MenuItem value="Daily">Daily</MenuItem>
        </TextField>
        <TextField
          id="maxNumberOfTransaction"
          label="Max Number Of Transaction"
          variant="outlined"
          type="number"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={maxNumberOfTransaction}
          onChange={e => setMaxNumberOfTransaction(e.target.value)}
        />
        <TextField
          id="maxTotalAmountOfTransaction"
          label="Max Total Amount Of Transaction"
          variant="outlined"
          type="number"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={maxTotalAmountOfTransaction}
          onChange={e => setMaxTotalAmountOfTransaction(e.target.value)}
        />

        <div>{/* <Loding/> */}</div>
        <div className={classes.buttonMarginStyle}>
          {/* {loading ? <LinearProgress /> : null} */}

          <Button
            variant="contained"
            className={classes.buttonStyle}
            color="primary"
            type="submit"
            disabled={loading}
            fullWidth>
            {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
            {editForm ? 'Update' : 'Save'}
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default TierAddEdit;
